module.exports = __webpack_public_path__ + "static/floral-4f4d5abfceaed832ddcfd3641d645d14.png";